import axios from "axios";

export const API = "/api";

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pyx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Tenant selector (hanya berdampak untuk SUPER_ADMIN; backend memaksa scope
  // Korda/Korwil untuk role lain sehingga nilai ini tidak bisa memperluas akses).
  const korda = localStorage.getItem("pyx_korda");
  if (korda) config.params = { korda, ...(config.params || {}) };
  return config;
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Terjadi kesalahan";
}

export default api;
